

import api from './api';

export interface User {
  id: string;
  name: string;
  email: string;
  role: string;
  is_active: boolean;
  job_title?: string;
  department?: string;
  phone_number?: string;
  location?: string;
  last_login_at?: string;
  created_at: string;
  max_active_sessions: number;
  session_timeout_hours: number;
  receive_notifications: boolean;
  api_access: boolean;
  require_password_reset?: boolean;
  restrictions?: {
    vendors?: string[];
    business_units?: string[];
    risk_groups?: string[];
    vendor_categories?: string[];
    geographies?: string[];
    criticality_levels?: string[];
  };
}

export interface CreateUserData {
  name: string;
  email: string;
  role: string;
  job_title?: string;
  department?: string;
  phone_number?: string;
  location?: string;
  max_active_sessions: number;
  session_timeout_hours: number;
  receive_notifications: boolean;
  api_access: boolean;
  send_invite: boolean;
}

export interface UpdateUserData {
  name?: string;
  role?: string;
  job_title?: string;
  department?: string;
  phone_number?: string;
  location?: string;
  is_active?: boolean;
  max_active_sessions?: number;
  session_timeout_hours?: number;
  receive_notifications?: boolean;
  api_access?: boolean;
}

export interface UserRestrictions {
  vendors?: string[];
  business_units?: string[];
  risk_groups?: string[];
  vendor_categories?: string[];
  geographies?: string[];
  criticality_levels?: string[];
}

const userApi = {
  getUsers: (includeInactive?: boolean) => 
    api.get(`/v1/users${includeInactive ? '?include_inactive=true' : ''}`),
  
  getUser: (userId: string) => 
    api.get(`/v1/users/${userId}`),
  
  createUser: (data: CreateUserData) => 
    api.post('/v1/users', data),
  
  updateUser: (userId: string, data: UpdateUserData) => 
    api.put(`/v1/users/${userId}`, data),
  
  deactivateUser: (userId: string) => 
    api.delete(`/v1/users/${userId}`),
  
  activateUser: (userId: string) => 
    api.post(`/v1/users/${userId}/activate`),
  
  // 👈 ADD THIS: Permanent delete user
  deleteUserPermanently: (userId: string) => 
    api.delete(`/v1/users/${userId}/permanent`),
  
  updateRestrictions: (userId: string, restrictions: UserRestrictions) => 
    api.post(`/v1/users/${userId}/restrictions`, { restrictions }),
  
  getRestrictions: (userId: string) => 
    api.get(`/v1/users/${userId}/restrictions`),
  
  resendInvite: (userId: string) => 
    api.post(`/v1/users/invite/resend/${userId}`),
};

// 👈 ADD THIS: Re-export the api instance so other files can use it
export { api };

export default userApi;